import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

const millisecondsInHour = 3600000;

export const useExpiredTimer = (expiresAt: string, bufferTimeMin?: number) => {
    const bufferTimeMinutes = bufferTimeMin && bufferTimeMin * 60 * 1000;

    const [isExpired, setIsExpired] = useState(() => {
        if (expiresAt) {
            return dayjs(expiresAt).isBefore(dayjs());
        }

        return false;
    });
    const [isBufferTime, setIsBufferTime] = useState(false);
    const [timeToExpire, setTimeToExpire] = useState('');
    const millisecondsToExpire = useRef(0);
    const timeoutRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (expiresAt) {
            const checkTime = () => {
                if (expiresAt) {
                    let milliseconds = dayjs(expiresAt).diff(dayjs());

                    if (milliseconds < 0) {
                        milliseconds = 0;
                    }
                    millisecondsToExpire.current = milliseconds;
                    const durationTime = dayjs.duration(milliseconds);
                    const hours = Math.floor(milliseconds / millisecondsInHour);

                    setTimeToExpire(
                        `${hours ? `${String(hours).padStart(2, '0')}:` : ''}${durationTime.format(
                            'mm:ss',
                        )}`,
                    );
                    if (milliseconds === 0) {
                        setIsExpired(true);
                    } else {
                        timeoutRef.current = setTimeout(() => {
                            checkTime();
                        }, 1000);
                    }
                }
            };

            checkTime();
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [expiresAt]);

    useEffect(() => {
        if (bufferTimeMinutes) {
            if (millisecondsToExpire.current < bufferTimeMinutes) {
                setIsBufferTime(true);
            }
        }
    }, [millisecondsToExpire, bufferTimeMinutes]);

    return {
        timeToExpire,
        isExpired,
        isBufferTime,
    };
};
